import React from 'react';

import { Box, Typography } from '@mui/material';

export default function ReviewHelp() {
  return (
    <Box sx={{ my: 2, display: 'grid', gap: 0.5 }}>
      <Typography variant="subtitle2">RM review key</Typography>
      <Typography variant="caption">
        Review covers handback today through 240 days away, when on sale or booked. Closed dates without bookings are
        excluded. Past handback is Final.
      </Typography>
      <Typography variant="caption">
        Financial risk: P50 margin must exceed $100 and reach 10%. Financial risk within 90 days is Urgent. Low
        confidence does not waive it. Zero-model forecasts skip financial and traveller triggers. Margin bands remain
        separate.
      </Typography>
      <Typography variant="caption">
        Empty zero-model forecasts below hedge are Watch with A16 Monitor. Review at 120 days before handback, when the
        no-bookings rule applies. Bookability and the 14-day open run still apply.
      </Typography>
      <Typography variant="caption">
        Traveller risk: at least 2 travellers and 20% below hedge. Smaller gaps are Watch. No bookings: bookable, within
        120 days, and open for at least 14 days. Reopening restarts the clock.
      </Typography>
      <Typography variant="caption">
        Known triggers take precedence over Assessment Incomplete, then Watch, Monitor and On Track. Missing checks are
        listed. “d+” is a lower bound from stored history.
      </Typography>
      <Typography variant="caption">
        Supplier-cost dilution needs a unit cost increase above 0.5% before P50 that causes a margin fall of at least 5
        percentage points. Holding pre-step unit cost must remove that fall.
      </Typography>
      <Typography variant="caption">
        Outcomes use two more than booked, two more than predicted, and the smallest recovery in twin pairs. Discounts
        apply to all future seats. Extra bookings are conditional; twin availability is not checked.
      </Typography>
      <Typography variant="caption">
        A01 reduce surcharge · A02 targeted discount · A04 marketing support · A08 handback extension · A09 hide to
        verify · A11 maintain price and availability · A12 upward pricing · A14 supply escalation · A15 resolve data ·
        A16 monitor.
      </Typography>
      <Typography variant="caption">
        Priority: urgent losses, urgent below minimum, then other action by recoverable opportunity. Amounts within 10%
        compare risk proportion, count and handback. The draft score is relative priority and remains to validate with
        RM.
      </Typography>
    </Box>
  );
}
